export class PPhosted {
  usersIpTerminal: number;
  usersFax2Email: number;
  usersAnalogFax: number;
  usersCentralizedVoiceMail: number;
  usersReserve: number;
  usersAvailable: number;
  nodes: number;
  usersMonthlyCost: number;
  nodesMonthlyCost: number;
  totalUserNumber?: number;
  totalCost?: number;

  softphones: number;
  softphoneMonthlyCost: number;

  connectorStandard: number;
  connectorStandardMonthlyCost: number;
  connectorStandardUniqueCost: number;

  connectorApi: number;
  connectorApiMonthlyCost: number;

  constructor() {
    this.usersIpTerminal = 5;
    this.usersFax2Email = 0;
    this.usersAnalogFax = 0;
    this.usersCentralizedVoiceMail = 0;
    this.usersReserve = 0;
    this.usersAvailable = 5;
    this.nodes = 0;
    this.usersMonthlyCost = 15;
    this.nodesMonthlyCost = 5;
    this.softphones = 0;
    this.softphoneMonthlyCost = 2;
    this.connectorStandard = 0;
    this.connectorStandardMonthlyCost = 2;
    this.connectorStandardUniqueCost = 0;
    this.connectorApi = 0;
    this.connectorApiMonthlyCost = 2;
  }

}



// WEBPACK FOOTER //
// ./src/models/PPhosted.ts